import { latestList } from "@/mocks/chigua";

export default function LatestGrid() {
  return (
    <section id="latest" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
              <i className="ri-time-fill"></i> 时间线 · 封面速览
            </span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">吃瓜福利最新发布</h2>
            <p className="mt-2 text-sm text-foreground-600">每张封面都对应一条热讯，按发布时间从新到旧排好，一目了然。</p>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-refresh-line animate-spin text-primary-500"></i>
            <span className="whitespace-nowrap">刚刚已同步实时更新</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {latestList.map((item) => (
            <a
              key={item.id}
              href="#latest"
              className="group overflow-hidden rounded-lg bg-background-50 border border-background-200 transition-colors hover:border-primary-300"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-medium text-primary-600 whitespace-nowrap">
                  {item.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-600">
                  {item.title}
                </h3>
                <div className="mt-2.5 flex items-center justify-between text-[11px] text-foreground-500">
                  <span className="whitespace-nowrap">{item.meta}</span>
                  <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-0.5"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}